import * as React from 'react';
import { useContext } from 'react';

import type { PageConfig_DomainPillsComponentMetadataFragment as DomainPillsComponentType } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfig_DomainPillsComponentMetadata';

export type DomainPillsContextType = {
  domains?: DomainPillsComponentType['domains'] | null;
};

const DomainPillsContext = React.createContext<DomainPillsContextType | undefined>(undefined);

export const useDomainPills = () => {
  const context = useContext(DomainPillsContext);

  return {
    domains: context?.domains,
  };
};

export default DomainPillsContext;
